import CompareTable from "../Pharmacy/PharmacyPlan/PharmacyCompareTable";
import { TABLE_STYLES } from "../Pharmacy/PharmacyPlan/PharmacyPlan.constants";
import { getDefaultCollapsed, ORIGIN_TITLE, shouldIncludeComparisonItem, STICKY_HEADER_HEIGHT, TARGET_TITLE } from "./Compare.constants";
import CompareRow from "./CompareRow";
import { CompareTitle } from "./CompareTitle";
import CustomPanel, { EPanelStyleType } from "./CustomPanel";
import { IEntityMetadataSectionProps } from "./types";

const EntityReferencesPanel: React.FC<IEntityMetadataSectionProps> = (props) => {
    if (props.entityProps.compareVM.referencesVM && (props.entityProps.compareVM.referencesVM.rowsVM.length ?? 0) > 0) {
        if (shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, props.entityProps.compareVM.referencesVM.changed)) {
            const referenceRows: JSX.Element[] = [];

            props.entityProps.compareVM.referencesVM.rowsVM.forEach((property) => {
                if (!shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, property.changed)) {
                    return;
                }

                referenceRows.push(
                    <CompareRow
                        key={property.propertyDefinition.logicalName}
                        name={<CompareTitle
                            changed={property.changed}
                            name={property.propertyDefinition.name}
                            entityProps={props.entityProps}
                        />}
                        valueVM={{
                            origin: property.origin,
                            target: property.target,
                            changed: property.changed,
                            mergeAction: property.mergeAction,
                        }}
                        entityProps={props.entityProps}
                    />
                );
            });

            return (
                <CustomPanel
                    id={`${props.entityProps.compareVM.uniqueId}-references`}
                    key={`${props.entityProps.compareVM.uniqueId}-references`}
                    data-references={'true'}
                    title={<CompareTitle
                        changed={props.entityProps.compareVM.referencesVM.changed}
                        name={'References'}
                        entityProps={props.entityProps}
                    />}
                    defaultCollapsed={getDefaultCollapsed(props.entityProps.configuration, props.entityProps.compareVM.referencesVM.changed)}
                    canCollapse={true}
                    stickyHeader={true}
                    stickyTop={props.entityProps.stickyOffset + STICKY_HEADER_HEIGHT}
                    stickyZIndex={150}
                    styleType={EPanelStyleType.Default}
                >
                    <CompareTable
                        className={props.entityProps.classNames}
                        tableStyles={TABLE_STYLES}
                        originHeader={ORIGIN_TITLE}
                        targetHeader={TARGET_TITLE}
                    >
                        {referenceRows}
                    </CompareTable>
                </CustomPanel>
            );
        }
    }

    return null;
};

export default EntityReferencesPanel;